// Photo gallery. `category` must match an id in galleryCategories.
export const galleryCategories = [
  { id: "facility", name: "Facility" },
  { id: "rooms", name: "Patient Rooms" },
  { id: "therapy", name: "Therapy & Activities" },
];

const gallery = [
  { id: 1, title: "Reception Area", category: "facility", img: "/assets/images/gallery/1.jpg" },
  { id: 2, title: "Consultation Room", category: "facility", img: "/assets/images/gallery/2.jpg" },
  { id: 3, title: "Patient Room", category: "rooms", img: "/assets/images/gallery/3.jpg" },
  { id: 4, title: "Therapy Room", category: "therapy", img: "/assets/images/gallery/4.jpg" },
  { id: 5, title: "Outdoor Area", category: "therapy", img: "/assets/images/gallery/5.jpg" },
  { id: 6, title: "Waiting Lounge", category: "facility", img: "/assets/images/gallery/6.jpg" },
];

export default gallery;
